import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { TruckHero } from './components/TruckHero';
import { SpecialOffers } from './components/SpecialOffers';
import { MenuSection } from './components/MenuSection';
import { SiteFooter } from './components/SiteFooter';
import { PhotoBanner } from './components/PhotoBanner';
export function App() {
  return <div className="min-h-screen w-full bg-cream font-sans text-ink selection:bg-salsa selection:text-white" data-id="element-0" data-mp="3f8ndzhg0d981">
      <SiteHeader data-id="element-1" data-mp="2mluairb8hvuc" />
      <main data-id="element-2" data-mp="2mmcd05ohp6ap">
        <TruckHero data-id="element-3" data-mp="2mmvkstkfeeb0" />
        <SpecialOffers data-id="element-4" data-mp="2mndp8dh8ryu0" />
        <MenuSection data-id="element-5" data-mp="2mjpy1kz9roig" />
        <PhotoBanner src="https://assets.cdn.filesafe.space/mAYT5j2uK2pp9sMVfZ1o/media/6ce011a3-5d2e-4925-9656-37684c5e8b5a.png" caption="Picture upload test 10/23" data-id="element-6" data-mp="31agnimde2bie" />
      </main>
      <SiteFooter data-id="element-7" data-mp="28tw6guwdqq51" />
    </div>;
}